export default __webpack_public_path__ + "media/images/ui-bg_gloss-wave_35_f6a828_500x100-437d053c3d8e0491db75537cfac2a614.png";